export default __webpack_public_path__ + "media/color/fct-afc21a34.svg";